import { config, authHeader } from '../helpers'
import { handleHttpResponse } from '../helpers';

export const EOCService = {
    getEOCList,
    changeStateOfEOC
}

function getEOCList({ EAN, page, nbElemsPerPage }) {
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/graphql', ...authHeader() }
    };
    const query = `adminEndOfContracts(
        EAN: ${EAN ? JSON.stringify(EAN) : null},
        page: ${page},
        nbElemsPerPage: ${nbElemsPerPage}
    )
    {
      eocList {
        id
        EAN
        clipodIDs
        effectiveDate
        registeredAt
        module
        label
        dgo
        isCanceled
        actionHistory {
            date
            adminEmail
            action
        }
      }
      lastPage
      nbFiltered
    }`;
    return fetch(`${config.apiUrl}/graphql?query={${query}}`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => data.adminEndOfContracts);
      })
}

function changeStateOfEOC({ adminID, eocID, isCancel, EAN }) {
  const query = `mutation{
      changeStateOfEOC(
          adminID: ${JSON.stringify(adminID)},
          eocID: ${JSON.stringify(eocID)},
          isCancel: ${isCancel},
          EAN: ${JSON.stringify(EAN)}
      ) {
          id
      }
  }`;
  const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/graphql', ...authHeader() },
      body: query
  }
  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
      return handleHttpResponse(response)
      .then(data => data.changeStateOfEOC);
  });
}